'use client';

import Link from 'next/link';
import * as styles from './OrganizerBanner.css';
import { analytics, analyticsEvents } from 'lib/analytics';

interface OrganizerButtonsProps {
  defaultLinkHref: string;
  outlineLinkHref: string;
}

export function OrganizerButtons({
  defaultLinkHref,
  outlineLinkHref
}: OrganizerButtonsProps) {
  const trackButtonClick = (buttonName: string) => {
    if (window?.dataLayer) {
      window.dataLayer.push({
        event: 'stck',
        stckEventCategory: 'home_click_banner',
        stckEventLabel: buttonName
      });
    }
  };

  const handleTrackAnalytics = (buttonLabel: string) => {
    analytics.sendEvent(analyticsEvents.sympla_for_producers_clicked, {
      link_sympla_for_producers_option: buttonLabel
    });
  };

  return (
    <div className={styles.buttonsContainer}>
      <Link
        className={styles.link.default}
        href={defaultLinkHref}
        onClick={() => {
          trackButtonClick('crie-seu-evento');
          handleTrackAnalytics('Crie seu evento');
        }}
      >
        Crie seu evento
      </Link>
      <Link
        className={styles.link.outline}
        target="_blank"
        rel="noopener noreferrer"
        href={outlineLinkHref}
        onClick={() => {
          trackButtonClick('veja-como-funciona');
          handleTrackAnalytics('Veja como funciona');
        }}
      >
        Veja como funciona
      </Link>
    </div>
  );
}
